const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Cards/ResponsibilitiesCard/ResponsibilitiesCard.tsx';
import { useIntl } from 'react-intl';
import { Typography } from '@mui/material';
import { IconTextTuples } from '../../IconTextTuples';
import textMap from './translations';
import * as React from 'react';
import { isEmpty } from '@cistec/common_web/utils/generalUtils';
import { useResponsibilityData } from 'App/store/zustaendigkeit';
import { DashboardCard } from '../DashboardCard';

export const ResponsibilitiesCard = (props: any) => {
    const { formatMessage } = useIntl();

    const [responsibilities, isPending] = useResponsibilityData();
    const hasData = !isEmpty(responsibilities);

    return (
        <DashboardCard iconClass="icons8-calendar" isDataLoading={isPending} hasData={hasData}>
            <Typography variant="subtitle1" component="h2" sx={{ color: 'primary.main' }} gutterBottom>
                {formatMessage(textMap.cardTitle)}
            </Typography>
            <IconTextTuples tuples={responsibilities} />
        </DashboardCard>
    );
};
